/**
 * PageLoadingIndicator Component
 *
 * Shows a loading bar at the top of the page during Inertia page transitions.
 */

import { useState, useEffect } from 'react';
import { router } from '@inertiajs/react';

export function PageLoadingIndicator() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const removeStartListener = router.on('start', () => {
      setLoading(true);
      setProgress(0);
    });

    const removeProgressListener = router.on('progress', (event) => {
      if (event.detail.progress?.percentage) {
        setProgress(event.detail.progress.percentage);
      }
    });

    const removeFinishListener = router.on('finish', () => {
      setProgress(100);
      // Small delay to show completion before hiding
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 200);
    });

    return () => {
      removeStartListener();
      removeProgressListener();
      removeFinishListener();
    };
  }, []);

  if (!loading) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] h-1 bg-blue-100"
      role="progressbar"
      aria-label="Page loading"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full bg-blue-600 transition-all duration-300 ease-out"
        style={{
          width: `${progress > 0 ? progress : 30}%`,
          transition: progress === 0 ? 'width 10s ease-out' : 'width 0.3s ease-out',
        }}
      />
    </div>
  );
}
